"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildFormattedRefundableDates = exports.buildFormattedNonRefundableDates = exports.buildPartiallyRefundableCancellationPolicies = void 0;
var formatDate_1 = require("./formatDate");
var date_1 = require("./date");
var buildCancellationPolicies_1 = require("./buildCancellationPolicies");
var buildFormattedNonRefundableDates = function (nonRefundableDates) { return nonRefundableDates.map(function (range) {
    if (range.start === range.end) {
        return "" + formatDate_1.formattedDate(new Date(range.start));
    }
    return formatDate_1.formattedDate(new Date(range.start)) + " - " + formatDate_1.formattedDate(new Date(range.end));
}).join(' and '); };
exports.buildFormattedNonRefundableDates = buildFormattedNonRefundableDates;
var formatRange = function (days) { return days.length === 1 ? formatDate_1.formattedDate(days[0]) : formatDate_1.formattedDate(days[0]) + " - " + formatDate_1.formattedDate(days[days.length - 1]); };
var buildFormattedRefundableDates = function (checkIn, checkOut, nonRefundableDates) {
    var ranges = [];
    var leadingDays = date_1.getDays(new Date(checkIn), new Date(nonRefundableDates[0].start), false);
    if (leadingDays.length > 0) {
        ranges.push(formatRange(leadingDays));
    }
    if (nonRefundableDates.length > 1) {
        for (var i = 0; i < nonRefundableDates.length - 1; i++) {
            var daysBetweenRanges = date_1.getDays(date_1.addDays(new Date(nonRefundableDates[i].end), 1), new Date(nonRefundableDates[i + 1].start), false);
            ranges.push(formatRange(daysBetweenRanges));
        }
    }
    var trailingDays = date_1.getDays(date_1.addDays(new Date(nonRefundableDates[nonRefundableDates.length - 1].end), 1), new Date(checkOut), false);
    if (trailingDays.length > 0) {
        ranges.push(formatRange(trailingDays));
    }
    return ranges.join(' and ');
};
exports.buildFormattedRefundableDates = buildFormattedRefundableDates;
var buildPartiallyRefundableCancellationPolicies = function (_a, options) {
    var checkIn = _a.checkIn, checkOut = _a.checkOut, policies = _a.policies, nonRefundableDates = _a.nonRefundableDates;
    var policyDescriptions = [];
    var policiesIntTimezone = policies.map(function (policy) {
        var start = new Date(policy.start);
        if ((policy === null || policy === void 0 ? void 0 : policy.nights) === 0) {
            start = date_1.subDays(new Date(policy.end), 1);
        }
        return __assign(__assign({}, policy), { timezone: options.timezone, start: start, end: new Date(policy.end) });
    });
    policiesIntTimezone.sort(buildCancellationPolicies_1.sortPoliciesByStartDate);
    if (!policiesIntTimezone.length && !nonRefundableDates.length) {
        return {
            policies: [],
            description: [],
        };
    }
    var formattedNonRefundable = buildFormattedNonRefundableDates(nonRefundableDates);
    var formattedRefundable = buildFormattedRefundableDates(checkIn, checkOut, nonRefundableDates);
    policyDescriptions.push("Reservations are non-refundable on the following dates: " + formattedNonRefundable + ".");
    for (var _i = 0, policiesIntTimezone_1 = policiesIntTimezone; _i < policiesIntTimezone_1.length; _i++) {
        var policy = policiesIntTimezone_1[_i];
        var dateFormat = formatDate_1.formattedDateByTimezone(policy.start.toISOString(), options.timezone, options.midnightWrap);
        if (policyDescriptions.length === 1) {
            policyDescriptions.push("Free cancellation is applicable to the following dates (" + formattedRefundable + ") until " + dateFormat + " (local time of property).");
        }
        if (policy === null || policy === void 0 ? void 0 : policy.nights) {
            policyDescriptions.push("Cancellations made after " + dateFormat + " (local time of property) are subject to a " + policy.nights + " " + (policy.nights > 1 ? 'nights' : 'night') + " penalty plus taxes and fees for these dates.");
        }
        if (policy === null || policy === void 0 ? void 0 : policy.percent) {
            policyDescriptions.push("Cancellations made after " + dateFormat + " (local time of property) will result in a " + policy.percent + "% penalty of the stay charges and fees for these dates.");
        }
        if (policy === null || policy === void 0 ? void 0 : policy.amount) {
            policyDescriptions.push("Cancellations made after " + dateFormat + " (local time of property) will result in a " + policy.amount + " " + policy.currency + " fee for these dates.");
        }
    }
    policyDescriptions.push('If you fail to check-in for this reservation, or if you cancel or change this reservation after check-in, you may incur penalty charges at the discretion of the property of up to 100% of the booking value.');
    return {
        policies: policiesIntTimezone,
        description: policyDescriptions,
    };
};
exports.buildPartiallyRefundableCancellationPolicies = buildPartiallyRefundableCancellationPolicies;
